import { Loader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { EditClient } from '~/features/EditClient';
import { EditClientHeader } from '~/features/EditClientHeader';
import { LegacyEditClient } from '~/features/LegacyEditClient';
import { getEnvFeatureFlag } from '~/utils/getEnvFeatureFlag';
import styles from './EditClientScreenContent.module.scss';

type Props = {
  clientId: number;
};

export const EditClientScreenContent: React.FC<Props> = ({ clientId }) => {
  const { enableStaging } = getEnvFeatureFlag();

  return (
    <>
      <Suspense fallback={<Loader />}>
        <EditClientHeader clientId={clientId} />
      </Suspense>
      <div className={styles.content}>
        <Suspense fallback={<Loader />}>
          {/* enableStaging が ON（staging / development）のときのみ新フォームを表示 */}
          {enableStaging ? (
            <EditClient clientId={clientId} />
          ) : (
            <LegacyEditClient clientId={String(clientId)} />
          )}
        </Suspense>
      </div>
    </>
  );
};
